"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("../../stitches.config");

var CardDiv = (0, _stitches.styled)('div', {
  background: '$white',
  borderRadius: '10px',
  border: '1px solid $grey300',
  boxShadow: '0 5px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
  width: '100%',
  '@tablet': {
    width: '85%'
  },
  '@desktop': {
    width: '50%'
  }
});
var CardContentWrapper = (0, _stitches.styled)('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
});
var CardTitle = (0, _stitches.styled)('div', {
  fontWeight: '$semiBold',
  fontSize: '$large',
  marginBottom: '5px',
  textAlign: 'center'
});
/**
 * A basic card component that has a title and body.
 */

var Card = function Card(_ref) {
  var children = _ref.children,
      title = _ref.title;
  return /*#__PURE__*/_react.default.createElement(CardDiv, null, /*#__PURE__*/_react.default.createElement(CardContentWrapper, null, /*#__PURE__*/_react.default.createElement(CardTitle, null, title), children));
};

Card.defaultProps = {
  title: ''
};
var _default = Card;
exports.default = _default;